<template>
    <div id="app">
        <div class="suspension" v-if="$route.meta&&$route.meta.showContact&&update">
            <div class="sus-icon user" @click="$router.push('/user')">
                <img src="./assets/img/my.png" alt="" v-if="!Image">
                <img :src="Image" alt="" v-else>
                <div class="sus-text">我的</div>
            </div>
            <div class="line"></div>
            <div @click="openContact">
                <div class="sus-icon">
                    <img class="kefuImg" src="./assets/img/call.png" alt="">
                </div>
                <div class="sus-text">客服</div>
            </div>
        </div>
        <div class="suspension" v-if="$route.meta&&$route.meta.singleContact&&update" :style="{ bottom: $route.meta.styleFlag ? '1.6rem' : '.6rem' }">
            <div @click="openContact">
                <div class="sus-icon">
                    <img class="kefuImg" src="./assets/img/call.png" alt="">
                </div>
                <div class="sus-text">客服</div>
            </div>
        </div>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <i class="icon-back-to-top" id="backToTop" style="display:none"></i>
    
    </div>
    
</template>
<script>


export default {
    name: 'App',
    data(){
        return{
            Image:'',
            update:true,
        }
    },
    watch:{
        $route(val){
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            this.setShare();
        },
        "$root.myImg"(item){
            this.update = false
            this.Image=item
            this.update = true
        }
    },
    methods:{
        // user(){

        // },
        // toTopPlace(){
        //     document.body.scrollTop = document.documentElement.scrollTop = 0;
        // },
        setShare(){
            var userInfo=this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'';
            if(userInfo){
                var shareFromLmy=encodeURIComponent(userInfo.ShareToken);
              
                var option={
                    Desc:"订酒店，全球酒店随心选，差旅、旅游必备神器~",
                    Image:"https://lmy.cnbooking.net/logo.png",
                    Title:"龙猫游！",
                    Url:'https://lmy.cnbooking.net/openShare.html?shareFromLmy='+shareFromLmy
                }
                this.setConfigShare(option);
            }

        },
        // isWechatBrowser() {
        //     var ua = navigator.userAgent.toLowerCase();
        //     if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    
        //     } else {
        //         //如果在外部浏览器中打开，则使用如下代码跳转
        //         var path = this.$router.currentRoute.fullPath || '';
        //         var newUrl = 'weixin: //webview/loadurl?url=' + encodeURIComponent('https://lmy.cnbooking.net/') + "&referer=" + encodeURIComponent(path)
        //         window.location.href = newUrl;
        //     }
        // }
        
    },
    created(){
        // 检测页面环境
        var isWechat = /micromessenger/i.test(navigator.userAgent)
        this.dao.set('isWechat',isWechat)
        if(this.$route.query.GDflag){
            var GDflag = this.$route.query.GDflag || ""
            this.dao.set('GDflag',GDflag)
        }
        //保存当前分享的sharer
        this.isUserLogin();
        // this.configShare();
        this.setShare();
    },
    // destroyed () {
    //     this.dao.set('GDflag','')
    // }
}
</script>






// WEBPACK FOOTER //
// src/App.vue